<template>
    <BasicDialog :duration="duration / 1000" ref="basicDialogRef" v-if="show">
        <template v-slot:header>
            <div class="custom-money_header">
                自定义金额

                <i class="el-icon-error" @click="closeDialog"></i>
            </div>
        </template>

        <template>
            <div :class="['custom-money_box']">
                <div class="money-input">
                    <span>￥</span>
                    <el-input v-model="money" placeholder="请输入金额"></el-input>
                </div>

                <span :class="['tip', { warning: !!money && (isNaN(money) || Number(money) < 30) }]">
                    {{ isNaN(money) ? "请输入正确的金额" : "金额最低为30元" }}
                </span>
            </div>
        </template>

        <template v-slot:footer>
            <div class="custom-money_footer">
                <el-button :disabled="!money || (!!money && (isNaN(money) || money < 30))" @click="confirm">确定</el-button>
            </div>
        </template>
    </BasicDialog>
</template>

<script>
import BasicDialog from "./BasicDialog.vue";

export default {
    name: "InformationDialog",
    components: {
        BasicDialog,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        duration: {
            type: Number,
            default: 150,
        },
        value: {
            required: true,
        },
    },
    data() {
        return {
            money: undefined,
        };
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.money = this.value;
            }
        },
    },
    methods: {
        handleInputMoney(val) {
            console.log(val);
        },

        closeDialog() {
            return new Promise((reslove, reject) => {
                if (this.$refs.basicDialogRef) {
                    this.$refs.basicDialogRef.hiddenDialog();
                }

                setTimeout(() => {
                    this.$emit("close");

                    reslove(true);
                }, this.duration);
            });
        },

        confirm() {
            this.closeDialog().then((res) => {
                this.$emit("confirm", this.money);
            });
        },
    },
};
</script>

<style scoped lang="scss">
* {
    font-family: PingFang-SC;
    color: #323233;
}

::v-deep .dialog-box {
    background-color: #ffffff;
    border-radius: 2px !important;
}

::v-deep .dialog-box_header {
    .custom-money_header {
        padding: 30px;
        padding-bottom: 0;
        text-align: center;
        position: relative;
        font-size: 16px;
        font-weight: 600;
        box-sizing: border-box;

        .el-icon-error {
            position: absolute;
            right: 8px;
            top: 8px;
            color: #b0b0b0;
            font-size: 20px;
            cursor: pointer;
        }
    }
}

::v-deep .dialog-box_content {
    .custom-money_box {
        display: flex;
        justify-content: center;
        // align-items: center;
        flex-direction: column;
        gap: 4px;
        padding-inline: 20px;
        margin-top: 20px;
        padding-bottom: 20px;

        .money-input {
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #f1f1f1;
            width: 100%;
            box-sizing: border-box;
            padding-inline: 10px;
            font-size: 16px;

            .el-input-number {
                width: 100%;
            }

            .el-input__inner {
                background-color: transparent;
                color: #323233;
                text-align: left;
                border: none;
                padding-left: 0;
            }
        }

        .tip {
            color: #999999;
            font-size: 13px;

            &.warning {
                color: #ff0000;
            }
        }
    }
}

::v-deep .dialog-box_footer {
    .custom-money_footer {
        margin-top: 10px;
        padding-inline: 20px;
        padding-bottom: 30px;

        .el-button {
            width: 100%;
            border: none;
            background-color: #fc2b55;
            color: #ffffff;

            &.is-disabled {
                background-color: #fc2b557e;
            }
        }
    }
}
</style>
